import { Directive, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'h7',
})
export class H7Directive {
  constructor(el: ElementRef) {}
}
